import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'

export default class ParkingAnchor extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        // this.element.addEventListener('click', this.handleClick)
        const links = this.element.querySelectorAll('a')
        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault()
                console.log(link.getAttribute('href'))
                scrollToElement(document.querySelector(link.getAttribute('href')))
            })
        })
    }

    // handleClick = () => {
    //     // const newsletter = document.getElementById('footerNewsletter')
    //     // scrollToElement(newsletter)
    // }
}